import { createElement } from '@wordpress/element';

/* ── TextInput ── */
export const TextInput = ({ value = '', onChange, type = 'text', placeholder = '' }) => (
    <input
        className="pqd-input"
        type={type}
        value={value || ''}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
    />
);

/* ── Toggle (replaces CheckboxControl) ── */
export const Toggle = ({ checked, onChange, label }) => (
    <label className="pqd-toggle">
        <span
            className={`pqd-toggle__track${checked ? ' pqd-toggle__track--on' : ''}`}
            role="switch"
            aria-checked={checked}
            tabIndex={0}
            onClick={() => onChange(!checked)}
            onKeyDown={e => (e.key === ' ' || e.key === 'Enter') && onChange(!checked)}
        >
            <span className="pqd-toggle__thumb" />
        </span>
        {label && (
            <span className={`pqd-toggle__label${checked ? ' pqd-toggle__label--on' : ''}`}>
                {checked ? 'Enabled' : 'Disabled'}
            </span>
        )}
    </label>
);

/* ── RadioGroup (replaces RadioControl, horizontal layout) ── */
export const RadioGroup = ({ selected, options = [], onChange }) => (
    <div className="pqd-radio-group">
        {options.map(opt => {
            const val = opt.value ?? opt.key;
            const lbl = opt.label ?? opt.name;
            const active = selected === val;
            return (
                <label
                    key={val}
                    className={`pqd-radio-option${active ? ' pqd-radio-option--active' : ''}`}
                >
                    <input
                        type="radio"
                        name={`radio-${val}`}
                        value={val}
                        checked={active}
                        onChange={() => onChange(val)}
                        className="pqd-radio-option__input"
                    />
                    <span className="pqd-radio-option__dot" />
                    <span className="pqd-radio-option__text">{lbl}</span>
                </label>
            );
        })}
    </div>
);
